module.exports = __webpack_public_path__ + "84ea549692d60627d72b8c9700a1d7a9.svg";